<template>
    <div id="news">
        <el-button type="primary" @click="onInsert">新增</el-button>
        <el-button
                icon="el-icon-refresh-right"
                @click="refresh"
                :loading="loading">
            重新載入
        </el-button>
        <el-table
                :data="pagedData"
                empty-text="目前無公告"
                height="620px"
        >
            <el-table-column
                    prop="subject"
                    label="主旨"
            ></el-table-column>
            <el-table-column
                    label="發布時間"
            >
                <template #default="{row}">
                    {{row.range[0]}}
                </template>
            </el-table-column>
            <el-table-column
                    label="截止時間"
            >
                <template #default="{row}">
                    {{row.range[1]}}
                </template>
            </el-table-column>
            <el-table-column
                    label="優先等級"
            >
                <template #default="{row}">
                    {{row.top ? '置頂' : row.priority}}
                </template>
            </el-table-column>
            <el-table-column
                    label="置頂?"
            >
                <template #default="{row}">
                    {{row.top ? '是' : '否'}}
                </template>
            </el-table-column>
            <el-table-column
                    label="總是顯示?"
            >
                <template #default="{row}">
                    {{row.always ? '是' : '否'}}
                </template>
            </el-table-column>
            <el-table-column
                    label="逾期?"
            >
                <template #default="{row}">
                    <span :style="row.isDue ? 'color:orange' : ''">{{row.isDue ? '是' : '否'}}</span>
                </template>
            </el-table-column>
            <el-table-column>
                <template #default="{row}">
                    <el-button
                            type="primary"
                            @click="onEdit(row)"
                            size="small"
                    >
                        更新
                    </el-button>
                    <el-button
                            type="danger"
                            @click="onDelete(row)"
                            size="small"

                    >直接刪除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                style="margin-top: 10px;"
                background
                layout="total, prev, pager, next"
                :total="news.length"
                :page-size="pageSize"
                :current-page.sync="currentPage"
                @current-change="page => pageChange(page, news)"
        ></el-pagination>
        <el-dialog
                :visible.sync="show"
                top="1vh"
                :title="title"
                @opened="onOpened"
        >
            <el-form ref="form" :rules="rules" :model="form" label-width="150px">
                <el-form-item label="主旨" prop="subject">
                    <el-input
                            v-model="form.subject"
                            placeholder="請輸入主旨"
                    ></el-input>
                </el-form-item>
                <el-form-item prop="range" label="公告起訖">
                    <el-date-picker
                            type="datetimerange"
                            start-placeholder="請選擇公告開始時間"
                            end-placeholder="請選擇公告結束時間"
                            v-model="form.range"
                            value-format="yyyy-MM-dd HH:mm:ss"

                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="內文">
                    <vue-editor
                            v-model="form.content" style="font-size: initial;line-height: initial;"
                            placeholder="請輸入內文"
                    ></vue-editor>
                </el-form-item>
                <el-form-item label="是否置頂?">
                    <el-checkbox v-model="form.top"></el-checkbox>
                </el-form-item>
                <el-form-item label="總是顯示?">
                    <el-checkbox v-model="form.always"></el-checkbox>
                </el-form-item>
                <el-form-item label="優先等級">
                    <el-input-number v-model="form.priority" :max="999" :min="1" :disabled="form.top"></el-input-number>
                </el-form-item>
                <el-form-item label="已添加之附件" v-if="form.downloads.length"
                >
                    <el-tag v-for="download in form.downloads" :key="download.uuid"
                            closable
                            @close="removeCurrentAttach(download.uuid)"
                            style="margin-right: 2px;"
                    >
                        {{download.fullName}}
                    </el-tag>
                </el-form-item>
                <el-form-item label="附件" v-if="fileLimit">
                    <el-upload
                            ref="upload"
                            :before-upload="beforeUpload"
                            :before-remove="handleBeforeRemove"
                            :on-error="onUploadError"
                            :on-exceed="onExceedLimit"
                            :limit="fileLimit"
                            :headers="uploadHeaders"
                            :action="action"
                            :data="dataOptions"
                            :on-success="onUploadSuccess"

                    >
                        <el-button>選擇檔案</el-button>
                        <template #tip>
                            <div class="el-upload__tip">
                                檔案不超過5MB
                            </div>
                        </template>
                    </el-upload>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button type="primary" :loading="loading" @click="updateSubmit" v-if="mode==='update'">更新</el-button>
                <el-button type="primary" :loading="loading" @click="insertSubmit" v-else>新增</el-button>
                <el-button @click="onCancel">關閉</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
    import {mapState, mapActions, mapGetters} from 'vuex';
    import {VueEditor} from 'vue2-editor';

    import PagingMixin from '../../pagingMixin';
    import UploadMixin from '../../uploadMixin';
    const defaultLimit = 3;
    const defaultForm = {
        subject: '',
        content: '',
        top: false,
        always: false,
        attaches: [],
        range: [],
        priority: 1,
        downloads:[],
    };
    export default {
        name: 'NewsManage',
        components: {
            VueEditor
        },
        data: () => ({
            form: {...defaultForm},
            mode: 'insert',
            show: false,
            rules: {
                subject: [
                    {required: true, message: '請輸入主旨', trigger: 'blur'}
                ],
                priority: [
                    {
                        range: {min: 1, max: 999},
                        message: '請輸入0~999間的數字!',
                        trigger: 'blur',
                        transform(value) {
                            return value.toString();
                        }
                    },
                ],
                range: [
                    {required: true, message: '請選擇起訖'}
                ]
            },
            fileLimit: defaultLimit,
        }),
        mixins: [PagingMixin, UploadMixin],
        props: {
            loading: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapState('news', ['news']),
            title() {
                return this.mode === 'insert' ? '新增公告' : '更新'
            }
        },
        methods: {
            ...mapActions('news', {
                getNews: 'getNewsAction',
                deleteNews: 'deleteNewsAction',
                updateNews: 'updateNewsAction',
                insertNews: 'insertNewsAction',
            }),

            async onDelete({id}) {
                try {
                    await this.$confirm('確定要刪除嗎?(刪除後將不能回復)', {
                        type: 'danger',
                    });
                    const {success} = await this.deleteNews(id);

                    if (success) {
                        this.$message.success('刪除成功');
                    } else {
                        this.$message.warning('取消失敗，請重試一次');
                    }
                } catch (e) {
                    if (e !== 'cancel') {
                        this.$message({
                            type: 'error',
                            message: '發生錯誤，請重試一次!'
                        });
                    }
                }
            },

            reset() {
                this.show = false;
                this.form = {...defaultForm};
                if(this.$refs.upload){
                    this.$refs.upload.clearFiles();
                }
                this.$refs.form.clearValidate();
                this.fileLimit = defaultLimit;
            },

            onOpened() {
                this.$refs.form.clearValidate();
            },

            onCancel() {
                this.reset();
            },

            onEdit(row) {
                this.mode = 'update';
                this.show = true;
                this.form = {...row};
                this.fileLimit = Math.max(0, defaultLimit - row.downloads.length);
            },

            onInsert() {
                this.form = {...defaultForm};
                this.mode = 'insert';
                this.show = true;
            },

            onUploadSuccess(res) {
                this.form.attaches.push(res);
            },

            async handleBeforeRemove(file) {
                await this.beforeRemove(file);
                this.form.attaches = this.form.attaches.filter(f => f.uid !== file.uid);
            },

            async updateSubmit() {
                const {form} = this.$refs;
                await form.validate(async (valid) => {
                    if (valid) {
                        const {success, messages = [], status} = await this.updateNews(this.form);
                        if (success) {
                            this.$message.success('更新成功!!');
                            this.reset();
                        } else {
                            this.$message.warning(messages.join(','));
                        }
                    }
                });
            },
            async insertSubmit() {
                const {form} = this.$refs;
                await form.validate(async (valid) => {
                    if (valid) {
                        const {success, messages = [], status} = await this.insertNews(this.form);
                        if (success) {
                            this.$message.success('新增成功!!');
                            this.reset();
                        } else {
                            this.$message.warning(messages.join(','));
                        }
                    }
                });
            },

            async removeCurrentAttach(key){
                this.form.downloads = this.form.downloads.filter(d => d.uuid !== key);
                this.fileLimit = Math.min(defaultLimit, this.fileLimit + 1);
                await this.removeFile({key, encrypted:true});
            },

            async refresh(){
                await this.getNews(true);
            }
        },
        watch: {
            news(current) {
                this.pagedData = this.pageData(current, 1);
                this.currentPage = 1;
            }
        },
        async created() {
            await this.getNews(true);
        }
    }
</script>

<style>
    #news #quill-container{
        height: 225px;
    }
</style>